import { render, staticRenderFns } from "./CalculateIcon.vue?vue&type=template&id=2940ae4a&scoped=true&"
import script from "./CalculateIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalculateIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2940ae4a",
  null
  
)

export default component.exports